import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <g strokeLinejoin="round">
      <path d="M7 8a1 1 0 1 0 0-2 1 1 0 1 0 0 2z" />
      <path d="M20 10.394L17.569 7 13 14m0-.364L9.667 10 6 14" strokeLinecap="round" />
    </g>
    <path d="M6 17h12M6 20h12" strokeLinecap="round" />
    <rect x="4" y="4" width="16" height="10" rx="2" strokeLinejoin="round" />
  </svg>
);
